import { createSelector } from 'reselect';

const selectSalesQuotes = (state: any) => state.salesQuotes;


export const selectSalesQuotesCurrentItem = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.current);

export const selectSalesQuotesListItems = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectSalesQuotesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSalesQuotesQueryItems = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.query);

export const selectSalesQuotesCreatedItem = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.create);

export const selectSalesQuotesUpdatedItem = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.update);

export const selectSalesQuotesReadItem = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.read);

export const selectSalesQuotesDeletedItem = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.delete);

export const selectSalesQuotesSearchedItems = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.search);

export const selectSalesQuotesItemsCount = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.count);

export const selectSalesQuotesItemsFilter = createSelector([selectSalesQuotes], (salesQuotes) => salesQuotes.filter);